/**
 * Vehicle revenue KPI filters
 */
export class KpiVehicleRevenueFilters {
	/**
	 * Period from date value
	 */
	periodFrom?: Date;

	/**
	 * Period to date value
	 */
	periodTo?: Date;
}
